<template>

    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'title'"
        class="col-12 col-md-4"
        v-model="component.componentProps.title"
        @input="$emit('input', component)"
        label="Title"
        placeholder="Title"
      />

      <LmTextInput
        ref="inputFocus"
        :id="id + 'subtitle'"
        class="col-12 col-md-4"
        v-model="component.componentProps.subtitle"
        @input="$emit('input', component)"
        label="Subtitle"
        placeholder="Subtitle"
      />

       <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="$emit('input', component)"
        label="Label"
        placeholder="Label"
        :help="$t('Label usado para visibilidad basada en una condición')"
      />

      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        label="Nombre"
        placeholder="placeholder"
      />

      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho vista escritorio"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />

      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.componentProps.size"
        :options="{
          content: [
            {value: 'sm',text: 'sm'},
            {value: 'md', text: 'md'},
            {value: 'lg', text: 'lg'},
          ]
        }"
        label="Size"
        :help="$t('Tamaño de los checkboxes')"
        @input="$emit('input', component)"
      />

       <LmSelect
                  :id="id + 'variant'"
                  class="col-12 col-md-4"
                  v-model="component.componentProps.variant"
                  :options="{
                    content: [
                      {value: '',text: 'default'},
                      {value: 'switch', text: 'switch'},
                    ]
                  }"
                  label="Variant"
                  :help="$t('Variante de visualización de los checkboxes')"
                  @input="$emit('input', component)"
                />

      <LmSelect
        :id="id + 'css'"
        class="col-12"
        v-model="selected"
        :options="{
          content: [
            {value: 'single',text: 'Single'},
            {value: 'multiple', text: 'Multiple'},
          ]
        }"
        label="Tipo de Checkbox"
        :help="$t('Selecciona el tipo de checkbox single o multiple')"
        @input="$emit('input', component)"
      />

      <div class=" w-100 mx-2 px-2 py-2" v-if="selected === 'single'">
         <div class="mt-2 row">
                <LmTextInput
                class="col-12 col-md-4"
                :id="id + 'placeholder'"
                v-model="component.componentProps.labelSingle"
                @input="$emit('input', component)"
                label="Label single checkbox"
                placeholder="Label single"
                @click.native="clearMultiple()"
                 />

                 <LmTextInput
                class="col-12 col-md-3"
                :id="id + 'value'"
                v-model="component.componentProps.checkValue"
                @input="$emit('input', component)"
                label="Value"
                placeholder="Value"
                @click.native="clearMultiple()"
                 />

                 <LmTextInput
                class="col-12 col-md-3"
                :id="id + 'uncheckedValue'"
                v-model="component.componentProps.uncheckedValue"
                @input="$emit('input', component)"
                label="Unchecked Value"
                placeholder="Unchecked Value"
                 />

                 <div class="col-12 col-md-2 mt-3 d-flex justify-content-center align-items-center">
                   <b-form-checkbox
                    :id="id + 'selected'"
                    v-model="component.componentProps.singleSelected"
                    name="selected-single"
                    :value="true"
                    :unchecked-value="false"
                    @input="$emit('input', component)"
                  >
                    Selected
                  </b-form-checkbox>
                 </div>

                  <LmSelect
                  :id="id + 'labelPosition'"
                  class="col-12 col-md-4"
                  v-model="component.componentProps.labelPosition"
                  :options="{
                    content: [
                      {value: 'left',text: 'left'},
                      {value: 'right', text: 'right'},
                    ]
                  }"
                  label="Label position"
                  :help="$t('Orientación de la pocición del label')"
                  @input="$emit('input', component)"
                />
            </div>
         </div>

<div class=" w-100 mx-2 px-2 py-2" v-if="selected === 'multiple'">
      <div class="col-12 mb-3 ">
        <div
          v-for="(option, index) in component.componentProps.options"
          :key="index"
          class="row align-items-center"
          >
          <LmTextInput
            :id="`id-${id}-${index}`"
            class="col-12 col-md-3"
            v-model="component.componentProps.options[index].text"
            @input="$emit('input', component)"
            label="Text"
            placeholder="Text"
          />
          <LmTextInput
            :id="`name-${id}-${index}`"
            class="col-12 col-md-3"
            v-model="component.componentProps.options[index].value"
            @input="$emit('input', component)"
            label="Value"
            placeholder="Value"
          />

          <b-form-checkbox
      :id="`d-${id}-${index}`"
       class="col-12 col-md-2"
      v-model="component.componentProps.options[index].disabled"
      :name="`checkbox-${id}`"
      :value="true"
      :unchecked-value="false"
    >
      disabled
    </b-form-checkbox>

    <b-form-checkbox
      :id="`c-${id}-${index}`"
       class="col-12 col-md-2"
      v-model="component.componentProps.options[index].checked"
      :name="`checkbox-checked-${id}`"
      :value="true"
      :unchecked-value="false"
    >
      checked
    </b-form-checkbox>

    <div class="mt-3 col-12 col-md-1 p-0 text-right">
      <font-awesome-icon
            :id="`trash-icon-${index}`"
            class="clickable"
            icon="trash"
            @click="removeOption(index)" />
    </div>

        </div>

    </div>
    <LmButton
          :id="`lm-button-${id}`"
          class="mt-2"
          type="button"
          :value="$t('Agregar opción')"
          @click.native="addOption" />

      <b-form-group label="Orientation" class="w-100 mt-4" v-slot="{ ariaDescribedbyOrientation }">
        <b-form-radio-group v-model="component.componentProps.orientation">
          <b-form-radio :aria-describedby="ariaDescribedbyOrientation" name="orientation-radio" value="inline" selected>horizontal</b-form-radio>
          <b-form-radio :aria-describedby="ariaDescribedbyOrientation" name="orientation-radio" value="stacked">vertical</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

       </div>

      <div class="col-12">
        <h5>Validation</h5>
        <div class="row align-items-center">
          <div class="custom-control custom-checkbox col-12 col-md mt-1">
            <b-form-checkbox
              :name="component.formObjectToSendToServerProperty"
              v-model="validations.required"
              @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
              >
              required
            </b-form-checkbox>
      <template v-if="validations.required">
            <LmTextInput
        ref="inputFocus"
        :id="id + 'invalidText'"
        class="mt-3"
        v-model="component.componentProps.invalidText"
        @input="$emit('input', component)"
        label="Invalid Text"
        placeholder="Invalid Text"
      />

      <LmTextInput
        ref="inputFocus"
        :id="id + 'validText'"
        class="mt-3"
        v-model="component.componentProps.validText"
        @input="$emit('input', component)"
        label="Valid Text"
        placeholder="Valid Text"
      />
      </template>

          </div>

        </div>
      </div>
      <LmConditionalBuilderUi
      v-if="isVisibleCondition"
        class="col-12 "
        :id="String(id)"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
import LmButton from '@/components/form/elements/LmButton'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  components: {
    LmButton
  },
  data () {
    return {
      selected: 'single',
      validations: {
        required: false
      },
      orientation: ''
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    },
    selected () {
      this.component.componentProps.type = this.selected
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clearMultiple () {
      this.component.componentProps.options = []
    },
    addOption () {
      this.component.componentProps.options.push({ text: 'Opcion', value: '', disabled: false, checked: false })
    },
    removeOption (optionIndex) {
      this.component.componentProps.options.splice(optionIndex, 1)
    }
  },
  created () {
    this.selected = this.component.componentProps.type
  }
}
</script>
